import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { StarlinkTableFilterSchema } from "./-zod-schema";

export const Route = createFileRoute(
  "/_staff/starlinks/_layout/user-terminals/",
)({
  validateSearch: zodValidator(StarlinkTableFilterSchema),
});
